import { render } from "./About.vue?vue&type=template&id=25fc5b71&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=25fc5b71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25fc5b71"

export default script